var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.6834,
    cy: 22.1932,
    r: 21.8182,
    fill: "#2F8AF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3678 17.1733C30.7802 16.7609 31.0071 16.2133 31.0071 15.6308C31.0071 15.0482 30.7802 14.5006 30.3678 14.0882L28.6376 12.358C28.2253 11.9457 27.6776 11.7188 27.0951 11.7188C26.5125 11.7188 25.9649 11.9457 25.5536 12.3569L13.9551 23.9195V28.7358H18.7693L30.3678 17.1733ZM27.0951 13.9006L28.8264 15.6297L27.0918 17.3577L25.3616 15.6286L27.0951 13.9006ZM16.1369 26.554V24.8249L23.8169 17.1689L25.5471 18.8991L17.8682 26.554H16.1369ZM13.9551 30.9177H31.4096V33.0995H13.9551V30.9177Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAvatar);
export default __webpack_public_path__ + "static/media/edit_avatar.24b7a3d5.svg";
export { ForwardRef as ReactComponent };